import { NotificationManager } from "react-notifications";
import axios from "../../../axios";
import { endpoints } from "../../endpoint";

export const getDataSuccess = (item) => {
  return {
    type: "GET_FAQ_SUCCESS",
    payload: item,
  };
};

export const getDataFailure = (error) => {
  return {
    type: "GET_FAQ_FAILURE",
    payload: error,
  };
};


export const faq = (payload) => (dispatch) => {
  axios
    .post(endpoints.faq,payload)
    .then((res) => {
      if (res.data.code === 1) {
        NotificationManager.success(res.data.message);
        dispatch(getDataSuccess(res.data.data));
      } else {
        // NotificationManager.error('Something went wrong!');
      }
    })
    .catch((err) => {
      // NotificationManager.error(err.message);
      dispatch(getDataFailure(err.message));
    });
};
